// extracted by mini-css-extract-plugin
export default {"relatenews":"index_relatenews_re5-a","relateHeader":"index_relateHeader_UqW9G","relateTitle":"index_relateTitle_4ccba"};